import { Reveal } from "@/components/ui/Reveal";
import { CONTACT } from "@/lib/site-data";

export function CtaBand({
  phone = CONTACT.phone,
  phoneHref = CONTACT.phoneHref,
  whatsappHref = CONTACT.whatsappHref,
  appointmentHref = "#contact",
  disablePopup = false,
}: {
  phone?: string;
  phoneHref?: string;
  whatsappHref?: string;
  appointmentHref?: string;
  disablePopup?: boolean;
} = {}) {
  return (
    <section className="relative overflow-hidden bg-brand-orange py-20">
      <div className="absolute inset-0 brand-cell-pattern opacity-[0.12]" />
      <Reveal className="relative mx-auto max-w-3xl px-5 sm:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold text-white">
          Ready to Redefine Yourself?
        </h2>
        <p className="mt-4 text-white/85">
          Book a free consultation with our specialists and get a treatment plan built
          around you.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-4">
          <a
            href={appointmentHref}
            {...(disablePopup ? {} : { "data-lead-popup": true })}
            className="rounded-full bg-brand-black px-7 py-3.5 text-sm font-semibold text-white shadow-lg hover:-translate-y-0.5 transition-transform"
          >
            Book Appointment
          </a>
          <a
            href={phoneHref}
            className="rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-brand-orange-deep shadow-lg hover:-translate-y-0.5 transition-transform"
          >
            Call {phone}
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-white/50 px-7 py-3.5 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
          >
            Chat on WhatsApp
          </a>
        </div>
      </Reveal>
    </section>
  );
}
